<template>
  <div class="i-date-time">
    <div class="field-label">
      {{ placeholder }}
    </div>

    <img src="../../../assets/app/icons/calender-icon.svg" class="calendar-icon">
    <div @click.stop="onDateClick">
      <VueCtkDateTimePicker
        ref="Datetimepicker"
        formatted="l"
        no-label
        only-date
        :label="dateValue"
        :no-button-now="noButtonNow"
        :noClearButton="true"
        :value="selectedDate"
        :no-header="true"
        :only-date="true"
        :max-date="maxDate"
        :locale="currentLocale"
        :translations="translations"
        @input="onInput"
        @validate="onValidate"
      />
    </div>

    <div
      v-if="showCurtain"
      ref="Curtain"
      class="date-time-curtain"
      @click="onCurtainDiv"
    ></div>
  </div>
</template>

<script>

import VueCtkDateTimePicker from '@/components/datetime';
import {endOfDay, startOfDay} from 'date-fns'

export default {
  name: "IDateTime",
  components: {VueCtkDateTimePicker},
  props: {
    value: {
      type: [Date, String, Number],
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    isAllDay: {
      type: Boolean,
      default: false,
    },
    noButtonNow: {
      type: Boolean,
      default: true,
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    customMaxDate: {
      type: String
    },
    customSelectedDate: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isLoading: false,
      selectedDate: null,
      showCurtain: false,
    }
  },

  computed: {
    maxDate() {
      return this.customMaxDate ? this.customMaxDate : new Date().toISOString()
    },
    dateValue() {
      let dateFormatter = new Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale)
      return dateFormatter.format(new Date(this.value));
    },
    currentLocale() {
      return this.$i18n.locale;
    },
    translations() {
      if (this.$i18n.locale === 'es') {
        return {
          now: 'Ahora',
          clear: 'Borrar',
          months: [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
          ],
          days: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
          am: 'a. m.',
          pm: 'p. m.'
        }
      } else if (this.$i18n.locale === 'ja') {
        return {
          now: '今',
          clear: 'クリア',
          months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          days: ['日', '月', '火', '水', '木', '金', '土'],
          am: '午前',
          pm: '午後'
        }
      } else if (this.$i18n.locale === 'fr') {
        return {
          now: 'Maintenant',
          clear: 'Effacer',
          months: [
            'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
            'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
          ],
          days: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
          am: 'AM',
          pm: 'PM'
        }
      } else if (this.$i18n.locale === 'de') {
        return {
          now: 'Jetzt',
          clear: 'Löschen',
          months: [
            'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
            'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
          ],
          days: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
          am: 'AM',
          pm: 'PM'
        }
      } else if (this.$i18n.locale === 'it') {
        return {
          now: 'Adesso',
          clear: 'Cancella',
          months: [
            'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
            'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
          ],
          days: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
          am: 'AM',
          pm: 'PM'
        }
      } else if (this.$i18n.locale === 'pt') {
        return {
          now: 'Agora',
          clear: 'Limpar',
          months: [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
          ],
          days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
          am: 'AM',
          pm: 'PM'
        }
      } else {
        return {
          now: 'Now',
          clear: 'Clear',
          months: [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ],
          days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          am: 'AM',
          pm: 'PM'
        }
      }
    }
  },

  methods: {
    onInput(val) {
      val = val.replace(/-/g, '/')
      const isoDate = new Date(val)
      let dateFrom = startOfDay(isoDate)
      this.minDate = dateFrom

      if (this.isAllDay) {
        dateFrom = endOfDay(isoDate)
      }

      this.rawDate = new Date(val);
      this.selectedDate = startOfDay(isoDate).toISOString()
      this.$emit('input', dateFrom.toISOString())
    },
    onValidate() {
      this.$refs.Datetimepicker.pickerOpen = !this.$refs.Datetimepicker.pickerOpen;
      this.showCurtain = false;

      let dateFrom = startOfDay(this.rawDate)

      if (this.isAllDay) {
        dateFrom = endOfDay(this.rawDate)
      }

      this.$emit('input', dateFrom.toISOString())
    },
    onDateClick() {
      if (this.$refs.Datetimepicker.pickerOpen) {
        this.showCurtain = true;
      }
    },
    onCurtainDiv() {
      this.showCurtain = false;
    },

    hideCurtainDiv() {
      if (this.$refs.Datetimepicker.pickerOpen && this.showCurtain) {
        this.showCurtain = false;
        this.$refs.Datetimepicker.pickerOpen = !this.$refs.Datetimepicker.pickerOpen
      }
    }
  },

  created() {
    this.selectedDate = this.customSelectedDate;
    if (this.customSelectedDate) {
      this.rawDate = new Date(this.customSelectedDate);
    }
    document.addEventListener('click', this.hideCurtainDiv);
  },

  beforeUnmount() {
    document.removeEventListener('click', this.hideCurtainDiv)
  }
}
</script>

<style lang="scss">
@import "IDateTime";
</style>
